// Typelizer digest db916c6a91db99802f8b05d471893279
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /signup/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/signup/new', {}, options),
    method: 'get',
  }),

  /** POST /signup */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/signup', {}, options),
    method: 'post',
  }),
}
